<script>
  export let params;
  export let currentRoute;
  export let question;
  export let addInitialData;
  export let modifyData;
  let options = [];

  /* Import packages */
  import Select from "svelte-select";
  import { onMount } from "svelte";

  /* Lauch when select client in Select */
  function handleSelectOption(e) {
    const optionIndex = options.findIndex(
      element => element.uuid == e.target.id
    );

    let newOptions = [...options];

    newOptions[optionIndex].value = e.target.checked;

    options = newOptions;

    modifyData({
      question_uuid: question.uuid,
      options: options
    });
  }

  /* Lauch when creal client in Select */
  function handleClearOption() {}

  onMount(async () => {
    options = question.options.map(option => {
      return { uuid: option.uuid, value: false };
    });

    addInitialData({
      question_uuid: question.uuid,
      options: options
    });
  });
</script>

<div class="px-4">
  <h3 class="text-3 mb-1">
    {question.description}{question.required ? ' *' : ''}
  </h3>
  {#if 'answers' in question}
    {#if question.answers}
      {#each question.answers as item}
        {#if item.answer == '1'}
          <i class="fa fa-check" />
        {:else}
          <i class="fa fa-times" />
        {/if}
        {item.question_option.value}
        <br />
      {/each}
    {/if}
  {:else}
    {#each question.options as option, i}
      <div class="chiller_cb">
        <input
          id={`${option.uuid}`}
          on:change={handleSelectOption}
          type="checkbox" />
        <label for={`${option.uuid}`}>{option.value}</label>
        <span />
      </div>
    {/each}
  {/if}
</div>
